import { themedStyled } from 'common/styles/styletron.theme';

export const CruiseSaleActionContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  backgroundColor: 'white',
  borderRadius: '8px',
  overflow: 'hidden',
});

export const ActionTrigger = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  padding: '8px 24px',
  borderRadius: '8px !important',
  background: 'white',
  border: `2px solid ${$theme.colors.primaryDefault}`,
  color: $theme.colors.primaryDefault,
  alignItems: 'center',
  display: 'flex',
  ':hover': {
    background: $theme.colors.primaryLightest,
    border: `2px solid ${$theme.colors.primaryDefault}`,
  },
  ':active': {
    background: $theme.colors.primaryLightest,
    border: `2px solid ${$theme.colors.primaryLight}`,
  },
  ...$theme.typography.body3Semibold,
}));

export const ActionItemButton = themedStyled<'div', { isDelete?: boolean }>(
  'div',
  ({ $theme, isDelete }) => ({
    cursor: 'pointer',
    background: $theme.colors.white,
    color: isDelete ? $theme.colors.redDefault : $theme.colors.primaryDefault,
    padding: '8px 24px',
    justifyContent: 'flex-start',
    ':hover': {
      background: isDelete
        ? $theme.colors.redLightest
        : $theme.colors.primaryLightest,
    },
    ':active': {
      background: isDelete
        ? $theme.colors.redLighter
        : $theme.colors.primaryLighter,
    },
    ...$theme.typography.body2Semibold,
  }),
);

export const FormContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  marginTop: '-16px',
  marginLeft: '-16px',
  marginRight: '-16px',
  paddingTop: '16px',
  paddingLeft: '16px',
  paddingRight: '16px',
  overflow: 'scroll',
}));

export const SummaryContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 199,
  boxShadow: '0px -4px 16px rgba(0, 0, 0, 0.12)',
  borderRadius: '8px 8px 0px 0px',
  padding: '16px',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}));

export const FormDivider = themedStyled('div', {
  marginTop: '120px',
});

export const SummaryLeftContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const SummaryRightContainer = themedStyled(
  SummaryLeftContainer,
  ({ $theme }) => ({
    marginTop: '16px',
    justifyContent: 'space-between',
    flex: 1,
    [$theme.mediaQuery.md]: {
      flex: 0,
      marginTop: 0,
    },
  }),
);

export const ScheduleCardHeader = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
}));

export const ScheduleCardHeaderRight = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
}));

export const OtherContainer = themedStyled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});
